import mitt from 'mitt';

const emitter = mitt();

export const OverlayService = {
    open(options) {
        // options: { title, message, type: 'success' | 'error' | 'info' }
        emitter.emit('open', options);
    },
    close() {
        emitter.emit('close');
    },
    on(event, handler) {
        emitter.on(event, handler);
    },
    off(event, handler) {
        emitter.off(event, handler);
    },
    emit(event, data) {
        emitter.emit(event, data);
    }
};
